import Icon from 'molecules/Icon';
import Link from 'molecules/Link';

import styles from 'components/HealthcareEntries/RelatedContent/related-content.module.scss';

import { CORE_MODEL_ID } from 'utils/constants';
import { isNonEmptyArray, replaceFirstPathSegment, titleCase } from 'utils/functions';

import type { IconIds } from 'molecules/Icon';
import type { FC } from 'react';
import type { TemplateModelData } from 'types/types';

interface RelatedContentProps {
  queryData: TemplateModelData;
}

interface RelatedContent {
  contentType: string;
  model: string;
  title: string;
  url: string;
}

const RelatedContent: FC<RelatedContentProps> = ({ queryData }) => {
  const relatedContent: RelatedContent[] =
    queryData?.data?.templateInfo?.relatedContent?.relatedContent
      ?.map(({ content }) => {
        const nestedContent = content?.value?.data;
        const isLCOnly = nestedContent?.templateInfo?.siteAvailability === 'LC Only';
        if (isLCOnly) {
          return null;
        }
        const model = content?.model?.includes('-') ? content?.model.split('-')[1] : content?.model || '';
        const contentType = titleCase(model) || '';
        const title = nestedContent?.templateInfo?.title ?? nestedContent?.title;
        const isCoreModel = content?.value?.['@originModelId'] === CORE_MODEL_ID;
        const url =
          isCoreModel || !nestedContent?.url
            ? nestedContent?.url
            : replaceFirstPathSegment(nestedContent.url, 'healthcare-insights');

        if (!title || !url) {
          return null;
        }

        return {
          contentType,
          model,
          title,
          url,
        };
      })
      ?.filter((item): item is RelatedContent => Boolean(item)) || [];

  if (!isNonEmptyArray(relatedContent)) {
    return null;
  }

  return (
    <>
      <section aria-label="Related Content" className={styles.relatedArticleContainer}>
        <h5 className={styles.relatedArticleHeader}>Related Content</h5>
        <ul>
          {relatedContent?.map(relatedItem => (
            <li key={relatedItem?.url} className={styles.relatedArticle}>
              <div className={styles.relatedArticleTitle}>
                <p className={styles.relatedArticleIcon}>
                  <Icon icon={relatedItem.model as IconIds} size={20} />
                </p>
                <p className={styles.contentTypeTitle}>{relatedItem.contentType.replace(/_/g, ' ')}</p>
              </div>
              <Link href={relatedItem.url || ''} className={styles.relatedArticleLink}>
                {relatedItem.title}
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </>
  );
};

export default RelatedContent;
